import React, {useState} from 'react';
import {Container} from "react-bootstrap";
import {CustomButton, TabBar, TabItem} from "../components";
import {ActiveCircleIcon, CheckWhiteIcon, CircleCheckICon} from "../assets";
import {PATH_APP} from "../routes/paths";
import 'react-mobile-style-picker/dist/index.css'
import {Link} from "react-router-dom";
import ActivityPicker from "../components/activity-picker";
import Low from "../assets/severity-icon/low";
import VeryLow from "../assets/severity-icon/very-low";
import Medium from "../assets/severity-icon/medium";
import High from "../assets/severity-icon/high";
import VeryHigh from "../assets/severity-icon/very-high";
import {useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import {FormProvider} from "../components/hook-form";
import {toast} from "react-toastify";
import CircleEmptyIcon from "../assets/circle-empty-icon";
import BackIcon from "../assets/back-icon";
import Header from "../components/header";

function Activity() {
    const [active, setActive] = useState();
    const methods = useForm();
    const navigate = useNavigate();

    const {
        handleSubmit,
    } = methods;
    const onSubmit = async () => {
        localStorage.setItem('activity', active)
        if (localStorage.getItem('activity') === active && localStorage.getItem('activity') !== '' && localStorage.getItem('activity') !== undefined) {
            navigate(PATH_APP.userDisease)
        }else{
            toast.error("فیلد فعالیت الزامی است", {
                position: "bottom-left",
                autoClose: 5000,
                rtl: true,
            })
        }
    };
    return (
        <div id="information-page">
            <Header header="white-header" link={PATH_APP.userInformation} title="اطلاعات شخصی"/>
            <header className="d-flex justify-content-between align-items-center">
                <Container style={{paddingRight: "0", paddingLeft: "0", marginTop: "88px"}}>
                    <TabBar>
                        <div>
                            <TabItem href="#"
                                     icon={<CircleCheckICon/>}
                                     title="اطلاعات شخصی"/>
                        </div>
                        <div>
                            <div style={{borderTop: "3px dotted #37C26F", width: "15px"}}/>
                        </div>
                        <div>
                            <TabItem href="#"
                                     icon={<CircleCheckICon/>}
                                     title="اطلاعات بدن"/>
                        </div>
                        <div>
                            <div style={{borderTop: "3px dotted #37C26F", width: "15px"}}/>
                        </div>
                        <div>
                            <TabItem href="#"
                                     icon={<ActiveCircleIcon fill1="#21242F" fill2="#37C26F" stroke="#37C26F"/>} title="نوع برنامه"/>
                        </div>
                        <div>
                            <div style={{borderTop: "3px dotted #434857", width: "15px"}}/>
                        </div>
                        <div>
                            <TabItem href="#"
                                     icon={<CircleEmptyIcon fill="#21242F" stroke="#525767"/>} title="سابقه بیماری"/>
                        </div>
                    </TabBar>
                </Container>
            </header>
            <Container style={{height:"90vh"}}>
                <>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Container>
                            <div>
                                <h5 className="page-title mt-4 mb-4"> در حال حاضر چه مقدار فعالیت روزانه دارید؟ </h5>
                            </div>
                            <div>
                                <ActivityPicker id="seldom" className={active === 'seldom' ? 'active' : ''}
                                                icon={<VeryLow/>} onClick={(e) => {
                                    setActive(e.target.id)
                                }}>
                                    <span>خیلی کم</span>
                                </ActivityPicker>
                                <ActivityPicker id="low" className={active === 'low' ? 'active' : ''} icon={<Low/>}
                                                onClick={(e) => {
                                                    setActive(e.target.id)
                                                }}>
                                    <span>کم</span>
                                </ActivityPicker>
                                <ActivityPicker id="medium" className={active === 'medium' ? 'active' : ''}
                                                icon={<Medium/>} onClick={(e) => {
                                    setActive(e.target.id)
                                }}>
                                    <span>متوسط</span>
                                </ActivityPicker>
                                <ActivityPicker id="high" className={active === 'high' ? 'active' : ''} icon={<High/>}
                                                onClick={(e) => {
                                                    setActive(e.target.id)
                                                }}>
                                    <span>زیاد</span>
                                </ActivityPicker>
                                <ActivityPicker id="intense" className={active === 'intense' ? 'active' : ''}
                                                icon={<VeryHigh/>} onClick={(e) => {
                                    setActive(e.target.id)
                                }}>
                                    <span>خیلی زیاد</span>
                                </ActivityPicker>
                            </div>
                        </Container>
                        <footer className="fixed-bottom" style={{marginTop:"25px" , background:"#fff" , boxShadow:"1px -11px 12px 1px #2725251c" , borderRadius:"15px 15px 0 0" , padding:"15px" , backdropFilter:"blur(6px)" , backgroundColor:"rgb(234 234 234 / 50%)"}}>
                        <CustomButton>
                                <CheckWhiteIcon/>
                                <span  style={{
                                    display: 'block'
                                }}> ثبت مشخصات</span>
                            </CustomButton>
                        </footer>
                    </FormProvider>
                </>
            </Container>
        </div>
    )
        ;
}

export default Activity;
